// LSM cart picks (canvas Cart board): fills the "Pairs with your ..." block in the cart
// drawer with the first item's complementary products, and adds a pick to the cart.
// Horizon re-renders the drawer after every cart change, so the block is refilled each time.
import { CartUpdateEvent } from '@theme/events';

const cache = new Map();

async function picksFor(productId) {
  if (!cache.has(productId)) {
    const url = `${window.Shopify?.routes?.root || '/'}recommendations/products?product_id=${productId}&limit=4&intent=complementary&section_id=lsm-cart-pairs-results`;
    cache.set(
      productId,
      fetch(url)
        .then((response) => (response.ok ? response.text() : ''))
        .catch(() => '')
    );
  }
  return cache.get(productId);
}

async function fill() {
  const block = document.querySelector('[data-lsm-cart-pairs]');
  if (!block || block.dataset.filled === block.dataset.productId + block.dataset.inCart) return;
  const grid = block.querySelector('[data-lsm-cart-pairs-grid]');
  const html = await picksFor(block.dataset.productId);
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const inCart = new Set((block.dataset.inCart || '').split(','));
  const picks = [...doc.querySelectorAll('[data-lsm-pair]')].filter((pick) => !inCart.has(pick.dataset.productId)).slice(0, 2);
  grid.replaceChildren(...picks);
  block.hidden = picks.length === 0;
  block.dataset.filled = block.dataset.productId + block.dataset.inCart;
}

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-lsm-pair-add]');
  if (!button) return;
  event.preventDefault();
  button.disabled = true;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(button.dataset.lsmPairAdd), quantity: 1 }] }),
    });
    if (!response.ok) throw new Error('add failed');
    const cart = await (await fetch(`${root}cart.js`)).json();
    document.dispatchEvent(new CartUpdateEvent(cart, 'lsm-cart-pairs', { itemCount: cart.item_count, source: 'lsm-cart-pairs' }));
  } catch (error) {
    button.disabled = false;
  }
});

if (!window.lsmCartPairsWatching) {
  window.lsmCartPairsWatching = true;
  const drawer = document.querySelector('cart-drawer-component') || document.body;
  new MutationObserver(() => fill()).observe(drawer, { childList: true, subtree: true });
}
fill();
